import { configure } from '@ackee/redux-utils';

import * as Log from '../loglevel';

configure({
    logger: Log,
});
